import { Injectable } from '@angular/core';
import { GaStateService } from '../services/ga-state.service';
import { GaEventService } from '../services/ga-event.service';
import { EVENT_BREADCRUMBS_CHANGED } from '../app-events';

export interface IBreadcrumb {
  title:string;
  state:string;
  stateParams:any;
  sref:string;
}

@Injectable()
export class BreadcrumbService {
  private _breadcrumbs:IBreadcrumb[] = [];
  private _index;

  constructor(
    private gaStateService:GaStateService,
    private gaEventService:GaEventService
  ) {
    // empty
  }

  get breadcrumbs():IBreadcrumb[] {
    return this._breadcrumbs;
  }

  set breadcrumbs(bcs:IBreadcrumb[]) {
    this._breadcrumbs = bcs;
    this.notifyBreadcrumbsChanged();
  }


  public getTitle():string {
    if (this._index < 0 || this._index >= this._breadcrumbs.length) {
      return;
    }
    return this._breadcrumbs[ this._index ].title;
  }

  public setTitle(idx:number, title:string):void {
    if (idx && title) {
      this._index = idx;
      this._breadcrumbs[ this._index ].title = title;
      this.notifyBreadcrumbsChanged();
    }
  }

  public create(title:string, state:string, stateParams:any):IBreadcrumb {
    return {
      title: title,
      state: state,
      stateParams: stateParams,
      sref: this.gaStateService.createSREF(state, stateParams)
    };
  }

  public empty():void {
    this._breadcrumbs = [];
    this.notifyBreadcrumbsChanged();
  }

  private notifyBreadcrumbsChanged():void {
    this.gaEventService.sendMessage(EVENT_BREADCRUMBS_CHANGED, this._breadcrumbs);
  }
}
